import { taskGroupsQuery } from "@common/api/quoting/task-group"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { ImportTaskGroupsDialog } from "./-components/import-dialog"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/task-groups/import",
)({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(taskGroupsQuery({ deleted: true })),
  component: ImportTaskGroupsModal,
})

function ImportTaskGroupsModal(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()

  const close = () =>
    navigate({ to: "/settings/quoting/task-groups", search: true })

  return (
    <ImportTaskGroupsDialog
      onClose={close}
      onImported={(created) => {
        const count = created.length
        showToast(
          "Imported",
          `${count} task group${count === 1 ? "" : "s"} added.`,
          "success",
        )
        close()
      }}
    />
  )
}
